(function () {
  'use strict';

  function nativeFormFor(modal) {
    var formId = modal.dataset.formId;
    var candidates = Array.from(document.querySelectorAll('form[is="product-form"]'));
    return candidates.find(function (form) {
      return form.getAttribute('id') === formId;
    }) || null;
  }

  function ensureHidden(form, name, marker) {
    var input = form.querySelector('[data-' + marker + ']');
    if (input) return input;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.setAttribute('data-' + marker, '');
    form.appendChild(input);
    return input;
  }

  function initialize(modal) {
    if (modal.dataset.recipeKey !== 'legacy_native') return;
    if (modal.dataset.zugLegacyNativeReady === 'true') return;
    modal.dataset.zugLegacyNativeReady = 'true';

    var fileInput = modal.querySelector('[data-zug-banner-file-input]');
    var fileHome = fileInput && fileInput.parentNode;
    var fileNextSibling = fileInput && fileInput.nextSibling;
    var submitting = false;
    var activeForm = null;
    var quantityBridge = null;
    var artworkProperty = null;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-zug-banner-open-upload]');
      if (!trigger || trigger.dataset.zugBannerOpenUpload !== modal.id || !modal.hidden) return;
      modal.dispatchEvent(new CustomEvent('zug-banner:open', {
        detail: { opener: trigger }
      }));
    });

    function restoreFileInput() {
      if (!fileInput || !fileHome) return;
      fileInput.setAttribute('form', modal.dataset.formId);
      if (fileNextSibling && fileNextSibling.parentNode === fileHome) {
        fileHome.insertBefore(fileInput, fileNextSibling);
      } else {
        fileHome.appendChild(fileInput);
      }
    }

    function removeTransientProperties() {
      if (quantityBridge) quantityBridge.remove();
      if (artworkProperty) artworkProperty.remove();
      quantityBridge = null;
      artworkProperty = null;
    }

    function finish(success) {
      submitting = false;
      restoreFileInput();
      removeTransientProperties();
      if (success) {
        modal.dispatchEvent(new CustomEvent('zug-banner:configuration-reset'));
      }
      activeForm = null;
    }

    modal.addEventListener('zug-banner:artwork-saved', function (event) {
      if (submitting || !event.detail) return;

      activeForm = nativeFormFor(modal);
      if (!activeForm || !fileInput || typeof activeForm.requestSubmit !== 'function') return;

      var mode = event.detail.mode;
      var hasFile = Boolean(fileInput.files && fileInput.files[0]);
      if (mode !== 'upload_artwork' && mode !== 'email_later') return;
      if (mode === 'upload_artwork' && !hasFile) return;

      if (mode === 'upload_artwork') {
        fileInput.disabled = false;
        fileInput.removeAttribute('form');
        activeForm.appendChild(fileInput);
      } else {
        artworkProperty = ensureHidden(
          activeForm,
          'properties[Artwork]',
          'zug-legacy-native-artwork'
        );
        artworkProperty.value = 'Upload Later';
        fileInput.disabled = true;
      }

      var pageQuantity = document.getElementById(modal.dataset.formId + '-quantity');
      if (pageQuantity && !pageQuantity.checkValidity()) {
        pageQuantity.reportValidity();
        finish(false);
        return;
      }

      var associatedQuantity = Array.from(activeForm.elements).find(function (element) {
        return element.name === 'quantity';
      });
      if (!associatedQuantity) {
        if (pageQuantity) {
          quantityBridge = ensureHidden(activeForm, 'quantity', 'zug-legacy-native-quantity');
          quantityBridge.value = pageQuantity.value;
        }
      }

      if (!activeForm.checkValidity()) {
        activeForm.reportValidity();
        finish(false);
        return;
      }

      submitting = true;
      activeForm.requestSubmit();
    });

    document.addEventListener('variant:add', function (event) {
      if (!submitting || event.target !== activeForm) return;
      finish(true);
    });

    document.addEventListener('cart:error', function (event) {
      if (!submitting || event.target !== activeForm) return;
      finish(false);
    });
  }

  function initializeAll() {
    document.querySelectorAll('[data-zug-banner-upload-modal][data-recipe-key="legacy_native"]')
      .forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
